import { apiCall } from '../../../utils';

export const getReferralInfo = () =>
  apiCall({
    url: '/subscription/referral-info/',
    method: 'get',
  });
